import { Component, OnInit, ViewChild } from '@angular/core';
import { NotificacaoService } from '../services/notificacao.service';
import { CarregandoService } from '../services/carregando.service';
import { ServicoEntregaService } from '../services/servico-entrega.service';
import { ServicoEntrega } from '../models/servico-entrega';
import { MatPaginator, PageEvent } from '@angular/material';
import { UtilitarioService } from '../services/utilitario.service';
import { Router } from '@angular/router';
import swal from 'sweetalert2';
import { PaginatorService } from '../services/paginator.service';

@Component({
  selector: 'app-servico-entrega',
  templateUrl: './servico-entrega.component.html',
  styleUrls: ['./servico-entrega.component.scss']
})
export class ServicoEntregaComponent implements OnInit {

  servicosEntregaFiltrados: ServicoEntrega[] = [];
  campoOrdenacao = 'de';
  ordenarDesc = false;
  paginacao = { tamanhoMaximo: 5, total: 0, paginaAtual: 1 };
  listaDeItensPorPagina = [];
  itensPorPagina = 10;
  @ViewChild('paginator', { static: false }) paginator: MatPaginator;


  constructor(
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private servicoEntregaService: ServicoEntregaService,
    private utilitarioService: UtilitarioService,
    private router: Router,
    private paginatorService: PaginatorService
  ) { }

  ngOnInit(): void {
    const pagination = this.paginatorService.consultarPaginacao();
    
    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarServicos();
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  buscarServicos() {
    this.carregandoService.mostra('buscarServicos');

    this.servicoEntregaService.consultarServicoEntregaComPaginacao(this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc').subscribe(
      dados => {
          this.servicosEntregaFiltrados = dados.itens;

          if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
            this.itensPorPagina = 10;
          }

          this.paginacao.total = dados.total;
          this.carregandoService.esconde('buscarServicos');
        },
      err => {
          this.carregandoService.esconde('buscarServicos');
          this.notificacaoService.erro(err);
      }
    )
  }

  novoServicoEntrega() {
    this.router.navigate(['/configuracoes/servico-entrega/novo']);
  }

  editarServicoEntrega(servicoEntrega) {
    this.router.navigate(['/configuracoes/servico-entrega/editar', servicoEntrega.id]);
  }

  excluirServicoEntrega(servicoEntrega: ServicoEntrega) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir o Serviço de Entrega?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluirServicoEntrega');
        this.servicoEntregaService.excluir(servicoEntrega.id).subscribe(resp => {

          this.notificacaoService.sucesso('Serviço de Entrega excluído com sucesso!!!');
          this.carregandoService.esconde('excluirServicoEntrega');
          this.buscarServicos();
        }, (erro) => {
          this.carregandoService.esconde('excluirServicoEntrega');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarServicos();
  }
}